<template>
    <div>
        <v-dialog v-model="showDialog" @click:outside="closeDialog" persistent max-width="700px">
            <v-card>
                <Loading />
                <v-toolbar dark>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{ $t('preferredWayToAddInstructions') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container class="text-center">
                    <v-row>
                        <v-col>
                            <v-btn @click="openAiInstruction" class="text-capitalize" outlined>{{
                                $t('aiGeneratedInstructions') }}</v-btn>
                        </v-col>
                        <v-col>
                            <v-btn @click="openInstructionAdd" class="text-capitalize" outlined>{{
                                $t('manualInput')}}</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Loading from '../common/Loading.vue'
export default {
    name: 'InstructionAddDialog',
    components: {
        Loading
    },
    methods: {
        openAiInstruction() {
            this.$store.dispatch('dashboard/switchShowInstructionAddDialog', false)
            this.$store.dispatch('dashboard/switchShowAiInstructionParameter', true)
        },
        closeDialog() {
            this.$store.dispatch('dashboard/switchShowInstructionAddDialog', false)
        },
        openInstructionAdd() {
            this.$store.dispatch('dashboard/switchShowInstructionAddDialog', false)
        }
    },
    computed: {
        showDialog() {
            return this.$store.getters['dashboard/showInstructionAddDialog']
        }
    },
}
</script>